export const StatusGroup = [
    {
        title: "예약가능",
        status: "available",
        color: "#7BC333",
    },

    {
        title: "예약진행",
        status: "proceed",
        color: "#a4c6df",
    },
    {
        title: "예약완료",
        status: "disable",
        color: "#dd107f",
    },
    {
        title: "전화문의",
        status: "tel",
        color: "#3b6c8d",
    },
] as const;
